"use strict";

export function feature_recipe_information_wysiwyg(el) {
    el.change(function () {
        var input = $('[js-recipelabel]').find('.active');
        $(input).attr('data-text', tinymce.get($('[js-recipelabel]').find('[js-wysiwyg]').attr('id')).getContent());
    });
}